import React, { useState, useEffect, useContext} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLRiskAnalysisService } from 'ml-services-common-react';
import { useTranslator } from '@jutro/locale';
import metadata from './MLRatingFactorHomeInspectionComponent.metadata.json5';
import messages from './MLRatingFactorHomeInspectionComponent.messages.js';

import { IntlContext } from '@jutro/legacy/locale';

const MLRatingFactorHomeInspectionComponent = (props) => {
    const { jobOrPolicyNumber, isQuote, isPolicy, isHomeOwners, styles, authHeader } = props;

    const translator = useTranslator();
    const intl = useContext(IntlContext);

    const [inspection, setInspection] = useState({});
    const [inspectionURL, setInspectionURL] = useState();

    const getInspectionURL = () => {
        const inspectionURLPromise = MLRiskAnalysisService.getMyriadSSOURL(authHeader);
        inspectionURLPromise.then((url) => {
            setInspectionURL(url);
        });
    };

    const updateInspection = (data) => {
        if (isHomeOwners && !_.isEmpty(data)) {
            setInspection({
                inspectionStatus: data.inspectionStatus,
                orderedDate: data.orderedDate,
                returnedDate: data.returnedDate,
                type: data.type,
                company: data.company,
                replacementCost: data.replacementCost,
                isPolicyBound: data.isPolicyBound,
                hasHomeInspectionBeenCompleted: data.hasHomeInspectionBeenCompleted
            });
        }
    };

    const getAndSetInspectionByJobNumber = (submissionNumber) => {
        if (_.isEmpty(inspection)) {
            const promise = MLRiskAnalysisService.getRAHomeInspectionDetailsMLByJobNumber(submissionNumber, authHeader);
            promise.then((data) => {
                updateInspection(data.lobs.homeowners.homeInspection);
            }, () => {
                setInspection({});
            });
        }
    };

    const getAndSetInspectionByPolicyNumber = (policyNumber) => {
        const promise = MLRiskAnalysisService.getRAHomeInspectionDetailsMLByPolicyNumber(policyNumber, authHeader);
        promise.then((data) => {
            updateInspection(data.lobs.homeowners.homeInspection);
        }, () => {
            setInspection({});
        });
    };

    useEffect(() => {
        getInspectionURL();
        if (isQuote) {
            getAndSetInspectionByJobNumber(jobOrPolicyNumber);
        } else if (isPolicy) {
            getAndSetInspectionByPolicyNumber(jobOrPolicyNumber);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderDate = (date) => {
        return (!date) ? '' : intl.formatDate(new Date(date.year, date.month, date.day), { year: "numeric", month: "2-digit", day: "2-digit" });
    };

    const getHomeInspectionTableOverrides = () => {
        const formatHomeInspectionData = (homeInspection) => {
            return [
                {
                    header: messages.inspectionStatus,
                    value: homeInspection.inspectionStatus
                },
                {
                    header: messages.inspectionOrdered,
                    value: renderDate(homeInspection.orderedDate)
                },
                {
                    header: messages.inspectionReturned,
                    value: renderDate(homeInspection.returnedDate)
                },
                {
                    header: messages.inspectionType,
                    value: homeInspection.type
                },
                {
                    header: messages.inspectionCompany,
                    value: homeInspection.company
                }
            ];
        };

        const getCellHeader = (rowData) => {
            // eslint-disable-next-line jsx-a11y/label-has-associated-control
            return <label>{ translator(rowData.header) }</label>;
        };

        const getCellValue = (rowData) => {
            return rowData.value;
        };

        return {
            homeInspectionTable: {
                data: formatHomeInspectionData(inspection),
                title: messages.homeInspection
            },
            headerColumn: {
                renderCell: getCellHeader
            },
            valueColumn: {
                renderCell: getCellValue
            }
        }
    }

    const showViewHomeInspectionButton = () => {
        return !_.isEmpty(inspection) && inspection.returnedDate !== undefined
         && inspection.hasHomeInspectionBeenCompleted === true && inspection.isPolicyBound;
    };

    const overrideProps = {
        viewHomeInspectionContainer: {
            visible: showViewHomeInspectionButton()
        },
        changeInspectionMessage: {
            visible: (inspection.type === 'Exterior-Only Onsite' || inspection.type === 'Exterior-Only Self-Survey') && inspection.inspectionStatus === 'On Hold'
        },
        keyRemindersSection: {
            visible: inspection.type !== null && inspection.type !== undefined
        },
        exteriorOnlyOnsiteSection: {
            visible: inspection.type === 'Exterior-Only Onsite'
        },
        exteriorOnlySelfSurveySection: {
            visible: inspection.type === 'Exterior-Only Self-Survey'
        },
        midValueSection: {
            visible: inspection.type === 'Mid-Value/Modified High Value'
        },
        highValueSection: {
            visible: inspection.type === 'High Value'
        },
        viewHomeInspection: {
            href: inspectionURL
        },
        ...getHomeInspectionTableOverrides()
    };

    const resolvers = {
        getClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.getClassNameMap}
        />
    );
};

MLRatingFactorHomeInspectionComponent.propTypes = {
    jobOrPolicyNumber: PropTypes.string.isRequired,
    isQuote: PropTypes.bool.isRequired,
    isPolicy: PropTypes.bool.isRequired,
    isHomeOwners: PropTypes.bool,
    styles: PropTypes.arrayOf(PropTypes.shape({}))
};

MLRatingFactorHomeInspectionComponent.defaultProps = {
    isHomeOwners: false,
    styles: undefined
};

export default MLRatingFactorHomeInspectionComponent;